import { ref, computed, shallowRef, type Component } from "#imports";
import type { ComponentInstance } from "vue";

const isOpen = ref(false);
const currentComp = shallowRef<Component | null>(null);
const componentInstance = ref<ComponentInstance<any>>();
const currentCompProps = ref<Record<string, any>>({});
const isFullscreen = ref(false);
type Options = {
  blockClose?: boolean;
  closeBtnColor?: string;
};
const options = ref<Options | undefined>();
const blockClose = computed(() => options.value?.blockClose);
const closeBtnColor = computed(() => options.value?.closeBtnColor || "");

export const useDialog = () => {
  const openDialog = <T extends Component>(
    component: T,
    compProps: T extends Component<infer P> ? Partial<P> : never,
    newOptions?: Options,
  ) => {
    currentComp.value = component;
    currentCompProps.value = compProps;
    options.value = newOptions;
    isOpen.value = true;
  };

  const registerComponent = (component: ComponentInstance<any>) => {
    componentInstance.value = component;
  };

  const closeDialog = async (userAction: boolean = false) => {
    if (typeof componentInstance.value?.closed === "function") {
      componentInstance.value.closed(userAction);
    }
    isOpen.value = false;
    isFullscreen.value = false;
    currentComp.value = null;
    currentCompProps.value = {};
  };

  const setDialogFullscreen = (value: boolean) => {
    isFullscreen.value = value;
  };

  return {
    isOpen,
    currentComp,
    currentCompProps,
    registerComponent,
    openDialog,
    closeDialog,
    blockClose,
    isFullscreen,
    setDialogFullscreen,
    closeBtnColor,
  };
};
